import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: "#2A9D8F",
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    /* position: "absolute",
    top: "50%",
    left: "0%",
    marginTop: -12,*/
    marginRight: 5,
  },
}));

export default function BotonLoading(props) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef();
  const [fondo, setFondo] = React.useState("#0B3845");
  const [fuente, setFuente] = React.useState("#FCFCFC");

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  React.useEffect(() => {
    if (props.load) {
      setLoading(false);
      setFondo("#0B3845");
      setFuente("#FCFCFC");
      setSuccess(true);
      if (props.close) {
        props.close();
      }
      if (props.setOpen) {
        props.setOpen(false);
      }
    }
  }, [props.load]);

  const handleButtonClick = () => {
    if (!loading) {
      if (props.onSubmit) {
        setTimeout(props.onSubmit(), 1000);
      }
      if (props.onClick) {
        setTimeout(props.onClick, 1000);
      }
      setFondo("#FCFCFC");
      setFuente("#0B3845");
      setSuccess(false);
      setLoading(true);
    }
  };

  return (
    <div className={classes.root}>
      {!props.disabled ? (
        <div className={classes.wrapper}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={buttonClassname}
            disabled={loading}
            onClick={handleButtonClick}
            style={{
              width: "100%",
              color: fuente,
              backgroundColor: fondo,
              display: "flex",
              direction: "row",
              alignItems: "center",
            }}
          >
            {loading ? (
              <>
                <CircularProgress
                  size={20}
                  className={classes.buttonProgress}
                />
                {props.texto}
              </>
            ) : (
              props.texto
            )}
          </Button>
        </div>
      ) : (
        <div className={classes.wrapper}>
          <Button
            variant="contained"
            color="primary"
            className={buttonClassname}
            disabled
            style={{ width: "100%", color: "#0B3845" }}
          >
            {props.texto}
          </Button>
        </div>
      )}
    </div>
  );
}
